import { useEffect } from "react";

const FOCUSABLE = 'a[href],button:not([disabled]),select,input,[tabindex]:not([tabindex="-1"])';

// Drawer behaviour on small screens: focus trap (toggle + panel), Escape closes, scroll lock.
export function useMenuA11y(open, close, toggleRef, panelRef) {
  useEffect(() => {
    const active = () => toggleRef.current && toggleRef.current.offsetParent !== null;
    if (!open || !active()) return undefined;
    const items = () => [toggleRef.current, ...(panelRef.current?.querySelectorAll(FOCUSABLE) || [])].filter((e) => e && e.offsetParent !== null);
    items()[1]?.focus();
    const onKey = (e) => {
      if (!active()) return;
      if (e.key === "Escape") { e.preventDefault(); close(); toggleRef.current?.focus(); return; }
      if (e.key !== "Tab") return;
      const list = items();
      const i = list.indexOf(document.activeElement);
      e.preventDefault();
      const n = list.length;
      list[i === -1 ? 0 : (i + (e.shiftKey ? -1 : 1) + n) % n].focus();
    };
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.removeEventListener("keydown", onKey); document.body.style.overflow = prev; };
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
}
